<script>
  import { auth } from "../etc/firebase.js"
  import { currentUser } from "../etc/store.js"

  // Listen for auth status change
  auth.onAuthStateChanged((user) => {
    if (user) {
      //console.log(user.email + " just logged in!")
      currentUser.email = user.email
    } else {
      currentUser.email = ""
      currentUser.loggedIn = false
      //console.log(currentUser.email + " just logged out!")
    }
  })

  let projects = [
    {
      publicViewing: true,
      name: "Piet Mondrian",
      discription: "Used css to imitate a Piet Mondrian's modern work for fun.",
      path: "/piet",
    },
    {
      publicViewing: false,
      name: "World Headline News",
      discription: "News api, async, await, etc.",
      path: "/news",
    },
    {
      publicViewing: true,
      name: "HTML Contenteditable",
      discription: "Click HERE to edit...",
      path: "#",
    },
    {
      publicViewing: true,
      name: "Data Visualization",
      discription: "Hook up D3 and some examples",
      path: "/d3",
    },
    {
      publicViewing: true,
      name: "CSS Image Experiments",
      discription: "(XiYi) Guas with yin and yang yaos",
      path: "/css_yinyang",
    },
    {
      publicViewing: false,
      name: "Auto Qi Gua Simulation",
      discription: "(XiYi) Initiate qi gua simulation & show statistics",
      path: "/autoqigua",
    },
    {
      publicViewing: true,
      name: "Gua Statistics",
      discription: "(XiYi) Gua Stat analysis",
      path: "/guastat",
    },
    {
      publicViewing: false,
      name: "AES hook up",
      discription: "Testing AES for end-2-end encryption",
      path: "/aes",
    },
    {
      publicViewing: false,
      name: "Progress and traisition",
      discription: "A few experiments on progress indicators and transitions",
      path: "/progress",
    },
    {
      publicViewing: false,
      name: "Taiji graph - Yin and Yang Fish",
      discription: "SVG, animation",
      path: "/taiji",
    },
  ]
</script>

<main>
  <h4>Sandbox</h4>
  <p>
    I put some of my code samples here mostly for future references. Each box
    below is some of my past or current experiements for other projects. Not all
    the components are shown to the public.
  </p>
  <hr />
  <div class="sand-grid">
    {#each projects as project}
      {#if (currentUser.email != "") | project.publicViewing}
        <div class="card ">
          <div class="card-body box">
            <a href={project.path}>
              <h5>{project.name}</h5>
              <!-- <p>{project.publicViewing} + {currentUser.email}</p> -->
              {#if project.name == "HTML Contenteditable"}
                <p class="a-p" contenteditable="true">
                  {project.discription}
                </p>
              {:else}
                <p class="a-p">
                  {project.discription}
                </p>
              {/if}
            </a>
          </div>
        </div>
      {/if}
    {/each}
  </div>
</main>

<style>
  .a-p {
    color: black;
    padding: 5px;
  }
  .sand-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    /* display: grid;
    height: auto;
    grid-gap: 1rem;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center; */
    /* justify-content: space-between; */
    /* grid-template-columns: 1fr 1fr 1fr 1fr; */
    place-items: center;
    /* margin: 10px; */
    /* padding: 10px; */
    grid-gap: 10px;
    background-image: linear-gradient(135deg, #e88931, #f0d08b);
  }

  .card {
    /* display: flex;
    flex-direction: column; */
    width: 200px;
    height: 180px;
    padding: 1rem;
    justify-content: space-between;
    justify-content: center;
  }
  .box {
    flex: 1 1 150px;
    text-align: center;
    /* justify-content: center; */
    /* text-justify: auto; */
    /* margin: 10px; */
    /* padding: 10px;
    grid-gap: 10px; */
  }
</style>
